import { IonApp, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Page from "./pages/PageContainer/Page";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";

/* Theme variables */
import InstallPWA from "./components/InstallPWA/InstallPWA";
// import ModalActualizarContrasenia from "../src/components/formComponents/ModalActualizarContrasena/ModalActualizarContrasena";
import LoginIonic from "./pages/Login/Login";
import PageError from "./pages/PageError/PageError";
import PaginaPrivacidad from "./pages/Privacidad/Privacidad";
import "./theme/general.css";
import "./theme/variables.css";

setupIonicReact();

const App = () => {
  return (
    <IonApp>
      <IonReactRouter>
        <InstallPWA />

        <Switch>
          <Route path="/" exact={true}>
            <Redirect to="/Login" />
          </Route>
          <Route path="/Login" exact={true}>
            <LoginIonic />
          </Route>
          <Route path="/Privacidad" exact={true}>
            <PaginaPrivacidad />
          </Route>
          <Route path="/portal/" exact={true}>
            <Redirect to="/portal/Inicio" />
          </Route>
          <Route path="/portal/:name" exact={true}>
            <Page />
          </Route>
          {/* Ruta de recuperación de contraseña desactivada por requerimiento del cliente */}
          {/* <Route path="/RecoveryPass/:token" exact>
            <ModalActualizarContrasenia />
          </Route> */}
          <Route path="/*">
            <PageError motivo="404" />
          </Route>
          <Route path="/*">
            <PageError motivo="404" />
          </Route>
        </Switch>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
